import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_PLUGIN_INSTALLED_LIST1ftwjhwye1pz5 as get_PLUGIN_INSTALLED_LIST } from './plugins/HttpClientPlugin.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { AttributesJsFn25rjfgcprgprf as AttributesJsFn } from '../../../../ktor-ktor-utils/io/ktor/util/Attributes.web.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { PlatformUtils_getInstanceitqdjrwn2jrm as PlatformUtils_getInstance } from '../../../../ktor-ktor-utils/io/ktor/util/PlatformUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function installPlugin($this, plugin) {
  if ($this.w5g_1.x4(plugin.r3()))
    return Unit_instance;
  var tmp0 = $this.w5g_1;
  var tmp2 = plugin.r3();
  // Inline function 'kotlin.collections.set' call
  var value = (scope) => {
    var tmp = get_PLUGIN_INSTALLED_LIST();
    var attributes = scope.t5f_1.p4m(tmp, HttpClientConfig$installPlugin$lambda$lambda);
    var config = ensureNotNull(scope.w5f_1.x5g_1.z4(plugin.r3()));
    var pluginData = plugin.p5h(config);
    plugin.q5h(pluginData, scope);
    attributes.m4m(plugin.r3(), pluginData);
    return Unit_instance;
  };
  tmp0.c5(tmp2, value);
}
function HttpClientConfig$engineConfig$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function HttpClientConfig$install$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function HttpClientConfig$installPlugin$lambda$lambda() {
  return AttributesJsFn(true);
}
var HttpClientConfigClass;
function HttpClientConfig() {
  if (HttpClientConfigClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.w5g_1 = LinkedHashMap().gc();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_0.x5g_1 = LinkedHashMap().gc();
        var tmp_1 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_1.y5g_1 = LinkedHashMap().gc();
        var tmp_2 = this;
        tmp_2.z5g_1 = HttpClientConfig$engineConfig$lambda;
        this.a5h_1 = true;
        this.b5h_1 = true;
        this.c5h_1 = false;
        this.d5h_1 = PlatformUtils_getInstance().u4n_1;
      }
      r5h(plugin, configure) {
        var previousConfigBlock = this.x5g_1.z4(plugin.r3());
        var tmp0 = this.x5g_1;
        var tmp2 = plugin.r3();
        // Inline function 'kotlin.collections.set' call
        var value = (_this__u8e3s4) => {
          var tmp0_safe_receiver = previousConfigBlock;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver(_this__u8e3s4);
          configure(!(_this__u8e3s4 == null) ? _this__u8e3s4 : THROW_CCE());
          return Unit_instance;
        };
        tmp0.c5(tmp2, value);
        installPlugin(this, plugin);
      }
      e5h(plugin, configure, $super) {
        var tmp;
        if (configure === VOID) {
          tmp = HttpClientConfig$install$lambda;
        } else {
          tmp = configure;
        }
        configure = tmp;
        var tmp_0;
        if ($super === VOID) {
          this.r5h(plugin, configure);
          tmp_0 = Unit_instance;
        } else {
          tmp_0 = $super.r5h.call(this, plugin, configure);
        }
        return tmp_0;
      }
      f5h(key, block) {
        // Inline function 'kotlin.collections.set' call
        this.y5g_1.c5(key, block);
      }
      q5g(client) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.w5g_1.b5().u1();
        while (_iterator__ex2g4s.v1()) {
          var element = _iterator__ex2g4s.w1();
          // Inline function 'kotlin.apply' call
          element(client);
        }
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = this.y5g_1.b5().u1();
        while (_iterator__ex2g4s_0.v1()) {
          var element_0 = _iterator__ex2g4s_0.w1();
          // Inline function 'kotlin.apply' call
          element_0(client);
        }
      }
      g5h(other) {
        this.a5h_1 = other.a5h_1;
        this.b5h_1 = other.b5h_1;
        this.c5h_1 = other.c5h_1;
        var tmp0 = this.w5g_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var map = other.w5g_1;
        tmp0.e5(map);
        var tmp0_0 = this.x5g_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var map_0 = other.x5g_1;
        tmp0_0.e5(map_0);
        var tmp0_1 = this.y5g_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var map_1 = other.y5g_1;
        tmp0_1.e5(map_1);
      }
    }
    initMetadataForClass($, 'HttpClientConfig', HttpClientConfig);
    HttpClientConfigClass = $;
  }
  return HttpClientConfigClass;
}
//region block: exports
export {
  HttpClientConfig as HttpClientConfigo6p492ed655g,
};
//endregion

//# sourceMappingURL=HttpClientConfig.mjs.map
